import React from 'react';
import './Vendor.css';

import { calculateAverageRating } from '../../utils';

import { FaStar } from 'react-icons/fa';

import { Link } from 'react-router-dom';



const Vendor = ({ vendor }) => {

  // Calculate the average rating of the vendor, based on user reviews
  const averageRating = calculateAverageRating(vendor);

  return (
    <div className="vendor-item">

      <img src={vendor.image} alt={vendor.title} /> {/* Vendor image */}

      <div className="content">

          {/* Vendor rating */}
          <div className='rating'>
            <div className='icon'>
              {/* Display star icons for rating */}
              <FaStar /> <FaStar /> <FaStar /> <FaStar /> <FaStar />
            </div>
            {/* Display average rating and number of comments */}
            {vendor.comments.length > 0 ? (
              <h5>{averageRating} ({vendor.comments.length})</h5>
            ) : (
              <h5>Not rated</h5>
            )}
          </div>

          {/* Vendor title with link to Vendor details page */}
          <Link to={{
              pathname: '/Vendors/' + vendor.title,
            }}
            state={vendor}>{vendor.title}
          </Link>

          <p>{vendor.details.location}</p> {/* Vendor Location */}

        </div>

    </div>
  );
};

export default Vendor;